module.exports = __webpack_public_path__ + "static/sword_of_sharpness-f13575f3b5a0eec45eb99cfd9978b2ab.jpeg";